/*
  SS 01.10.2026 - swipeable product-card images on collection and search pages.
  Markup: snippets/kalis-product-grid-item.liquid (swipe: true). CSS: snippets/ss-card-swipe.liquid.

  1) Loading. The extra images ship as data-srcset; a card's images are loaded when a finger touches it. Once the
     visitor has swiped one card, the 2nd image of every card near the viewport is loaded ahead, so later swipes
     never reveal an empty frame. Visitors who never swipe only pay for the hint card's 2nd image (measured: loading
     image 2 for every card on screen cost ~80 KB per card at 3x). Nothing happens on desktop (slide 1 only).
  2) Hint. Once its 2nd image is ready, the first card's images slide 40 % to the left and back, twice
     (CSS animation, timing measured on kappahl.com). On a first visit it waits until the Cookiebot dialog has
     been answered - the dialog and its dark backdrop cover the page, so the hint would play unseen. Skipped if
     the card is not on screen, has been touched, or the visitor prefers reduced motion; stopped by the first touch.
*/
(function () {
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  var SWIPE = '[data-ss-swipe]';
  var swiper = false; // has this visitor touched a card slider yet?

  function hydrate(img) {
    var srcset = img && img.getAttribute('data-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-srcset');
    }
  }

  function slideImage(swipe, i) {
    var slide = swipe.children[i];
    return slide && slide.querySelector('img');
  }

  // Calls back once the image has loaded, or not at all if that takes longer than `ms`.
  function whenLoaded(img, ms, cb) {
    if (!img) return;
    if (img.complete && img.naturalWidth) return cb();
    var timer = setTimeout(function () { cb = null; }, ms);
    img.addEventListener('load', function () { clearTimeout(timer); if (cb) cb(); }, { once: true });
  }

  document.addEventListener('touchstart', function (e) {
    var swipe = e.target.closest && e.target.closest(SWIPE);
    if (!swipe) return;
    swipe.querySelectorAll('img[data-srcset]').forEach(hydrate);
    swipe.ssTouched = true;
    swipe.classList.remove('ss-swipe--hint');
    if (!swiper) {
      swiper = true;
      watch();
    }
  }, { passive: true, capture: true });

  // Trackpad or keyboard scrolling in a narrow desktop window: no touchstart, so load on the first scroll.
  document.addEventListener('scroll', function (e) {
    if (e.target.matches && e.target.matches(SWIPE)) e.target.querySelectorAll('img[data-srcset]').forEach(hydrate);
  }, { passive: true, capture: true });

  var io = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      hydrate(slideImage(entry.target, 1));
      io.unobserve(entry.target);
    });
  }, { rootMargin: '200px 0px' });

  function watch() {
    if (!swiper) return;
    document.querySelectorAll(SWIPE).forEach(function (swipe) {
      if (swipe.ssWatched) return;
      swipe.ssWatched = true;
      if (io) io.observe(swipe);
      else hydrate(slideImage(swipe, 1));
    });
  }

  // Calls back when no cookie dialog covers the page: at once if the visitor answered it on an earlier visit
  // (CookieConsent cookie), otherwise after the answer. The dialog shows up late (0.6 s in NO, up to 2.5 s in DE)
  // and not at all in UK (Cookiebot loads there but shows nothing, measured 01.10.2026) or behind a content
  // blocker - so if none has appeared 3 s after the page started, go anyway.
  function afterConsent(cb) {
    if (/(^|;\s*)CookieConsent=/.test(document.cookie) || (window.Cookiebot && window.Cookiebot.hasResponse)) return cb();
    var state = document.getElementById('CybotCookiebotDialog') ? 'dialog' : 'waiting';
    function go(delay) {
      if (state === 'done') return;
      state = 'done';
      setTimeout(cb, delay);
    }
    window.addEventListener('CookiebotOnDialogDisplay', function () { if (state === 'waiting') state = 'dialog'; });
    window.addEventListener('CookiebotOnAccept', function () { go(300); }); // 300 ms: let the backdrop fade out
    window.addEventListener('CookiebotOnDecline', function () { go(300); });
    setTimeout(function () { if (state === 'waiting') go(0); }, Math.max(0, 3000 - performance.now()));
  }

  function hint() {
    var swipe = document.querySelector('.collection-grid__wrapper ' + SWIPE);
    if (!swipe || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var next = slideImage(swipe, 1);
    hydrate(next);
    whenLoaded(next, 4000, function () {
      afterConsent(function () {
        setTimeout(function () {
          var r = swipe.getBoundingClientRect();
          var visible = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
          if (swipe.ssTouched || visible < r.height * 0.6) return;
          swipe.addEventListener('animationend', function () {
            swipe.classList.remove('ss-swipe--hint');
          }, { once: true });
          swipe.classList.add('ss-swipe--hint');
        }, 400);
      });
    });
  }

  // The hint waits for the first card image, so its 2nd image never competes with it.
  var first = document.querySelector('.collection-grid__wrapper .grid-product img');
  var started = false;
  function start() {
    if (started) return;
    started = true;
    hint();
  }
  whenLoaded(first, 3000, start);
  setTimeout(start, 3000);

  document.addEventListener('collection:reloaded', watch);
})();
